var icon = require('vue-svgicon')
icon.register({
  'ks-icon-cc-strike': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M108.75 92a10.62 10.62 0 0 0 .07-1.27V36.48a9 9 0 0 0-2.55-6.48 8.48 8.48 0 0 0-6.38-2.65h-56l9.14 9.12H99.9v9.13H62.2l18.07 18H99.9v19.59zm-50.9-28.38H27.2v27.14h57.85zM30.64 36.48H27.2v9.12h12.58zm63.55 63.4h-67a8.48 8.48 0 0 1-6.38-2.65 9 9 0 0 1-2.55-6.47V36.48A9 9 0 0 1 20.83 30a8.77 8.77 0 0 1 1.85-1.48l-7.73-7.71 5.77-5.76 92.34 92.12-5.77 5.76z" fill-rule="evenodd"/>'
  }
})
